<template>
  <Disclosure
    v-slot="{ open }"
    as="nav"
    class="sm:py-1 border-b-2 border-[#FFD13C] dark:border-gray-800 font-semibold"
  >
    <div
      class="flex px-6 container md:max-w-2xl lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl justify-between mx-auto items-baseline"
    >
      <div class="relative flex h-14 sm:h-16 w-full">
        <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
          <!-- Mobile menu button-->
          <DisclosureButton
            class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset"
          >
            <span class="absolute -inset-0.5" />
            <span class="sr-only">Open main menu</span>
            <Bars3Icon v-if="!open" class="block size-6" aria-hidden="true" />
            <XMarkIcon v-else class="block size-6" aria-hidden="true" />
          </DisclosureButton>
        </div>
        <div class="flex sm:inset-y-0 sm:left-0 w-full">
          <div class="flex shrink-0 items-center mx-auto sm:mx-0 sm:left-0">
            <NuxtLink to="/blog">
              <NuxtImg
                src="/logo-movimento.png"
                width="180"
                height="38"
                quality="70"
                alt="Logo do Movimento Codernista"
                class="rounded-md"
              />
            </NuxtLink>
          </div>
          <div class="text-sm sm:text-lg hidden sm:ml-6 sm:block sm:absolute sm:right-0 sm:my-3">
            <div class="flex space-x-4">
              <a
                v-for="item in navigation"
                :key="item.name"
                :href="item.href"
                :class="[
                  item.current
                    ? 'bg-zinc-800 text-white'
                    : 'bg-zinc-500 text-zinc-50 hover:bg-zinc-700 hover:text-white',
                  'rounded-md px-3 py-2 text-sm font-medium',
                ]"
                :aria-current="item.current ? 'page' : undefined"
                >{{ item.name }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <DisclosurePanel class="sm:hidden">
      <div class="space-y-1 px-2 pt-2 pb-3">
        <DisclosureButton
          v-for="item in navigation"
          :key="item.name"
          as="a"
          :href="item.href"
          :class="[
            item.current
              ? 'bg-zinc-800 text-white'
              : 'bg-zinc-500 text-zinc-50 hover:bg-zinc-700 hover:text-white',
            'block rounded-md px-3 py-2 text-base font-medium',
          ]"
          :aria-current="item.current ? 'page' : undefined"
          >{{ item.name }}</DisclosureButton
        >
      </div>
    </DisclosurePanel>
  </Disclosure>
  <div class="py-1 border-b border-gray-300 dark:border-gray-800 font-semibold overflow-x-auto">
    <div
      class="px-6 flex container md:max-w-2xl lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl justify-between mx-auto items-baseline"
    >
      <ul class="flex self-center space-x-3 sm:space-x-6 text-sm sm:text-lg">
        <li
          class="px-5 py-1 my-2 border-2 dark:border-gray-800 font-semibold"
          :class="{ 'bg-[#0891b2] text-white': isActive('/blog/backend') }"
        >
          <NuxtLink to="/blog/backend"> BackEnd </NuxtLink>
        </li>
        <li
          class="px-5 py-1 my-2 border-2 dark:border-gray-800 font-semibold"
          :class="{ 'bg-[#0891b2] text-white': isActive('/blog/dados') }"
        >
          <NuxtLink to="/blog/dados"> Dados </NuxtLink>
        </li>
        <li
          class="px-5 py-1 my-2 border-2 dark:border-gray-800 font-semibold"
          :class="{ 'bg-[#0891b2] text-white': isActive('/blog/ferramentas') }"
        >
          <NuxtLink to="/blog/ferramentas"> Ferramentas </NuxtLink>
        </li>
        <li
          class="px-5 py-1 my-2 border-2 dark:border-gray-800 font-semibold"
          :class="{ 'bg-[#0891b2] text-white': isActive('/blog/carreira') }"
        >
          <NuxtLink to="/blog/carreira"> Carreira </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'

const route = useRoute()
function isActive(path: string) {
  return route.path.indexOf(path) >= 0
}

const navigation = [
  {
    name: 'Home',
    href: '/blog',
    current: !isActive('/blog/posts') && !isActive('/blog/tags'),
  },
  { name: 'Posts', href: '/blog/posts', current: isActive('/posts') },
  { name: 'Tags', href: '/blog/tags', current: isActive('/tags') },
]
</script>
